import { IInspector } from 'APIPackage/KnmModule/interfaces/IInspector';

import { IKnmInspectorSelectOption } from '../interfaces/IKnmInspectorSelectOption';

export const createKnmInspectorSelectOption = (knmInspector: IInspector): IKnmInspectorSelectOption => ({
  ...knmInspector,
  label: knmInspector.fullName,
  value: knmInspector.fullName,
  correlationToken: null,
  dateCreate: null,
  main: false,
  guid: null,
  positionErknm: null,
});
